<template>
    <div class="component-back">
        <div class="back-btn" @click="$router.go(-1)">
            <i class="icon-arrow-left"></i> Back  
        </div>
    </div>
</template>

<script>
export default {
    name: "Back",
}
</script>

<style scoped>
.component-back {
    /* 修改：让容器内按钮水平居中（核心） */
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中（可选，优化视觉） */
    padding: 20px;
    background-color: #ffffff;
}

.back-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    /* 新增：白字蓝底样式 */
    background-color: #2444cb; /* 蓝色背景（可自定义色值） */
    color: #ffffff; /* 白色文字 */
    /* 新增：按钮美化（可选，提升视觉体验） */
    padding: 8px 20px; /* 内边距，让按钮更饱满 */
    border-radius: 4px; /* 圆角，避免直角生硬 */
    border: none; /* 去除默认边框（若有） */
    justify-content: center; /* 按钮内部内容水平居中 */
    min-width: 120px; /* 最小宽度，保证按钮不会过窄 */
}
.icon-arrow-left {
    margin-right: 8px;
    /* 补充：确保图标也是白色，与文字统一 */
    color: #ffffff;
}
/* 可选：添加hover效果，提升交互体验 */
.back-btn:hover {
    background-color: #096dd9; /* 深色蓝，hover时变色 */
    transition: background-color 0.3s ease; /* 过渡动画，更丝滑 */
}
</style>

